export default __webpack_public_path__ + "static/media/LINKDIN.2b059ed4.svg";